<template>
  <div class="ps-text-field">
    <div class="pb-2">{{ $t(label) }}</div>
    <v-text-field
      color="primary"
      v-model="model"
      :rounded="rounded"
      :type="type ? 'text' : 'password'"
      :flat="flat"
      :outlined="outlined"
      :dense="dense"
      :disabled="disabled"
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :counter="counter"
      :filled="filled"
    >
      <template v-slot:append>
        <div class="d-flex align-center" style="gap: 8px">
          <slot name="append" />
          <v-icon small @click="handleKey">
            {{ type ? "fal fa-eye" : "fal fa-eye-slash" }}
          </v-icon>
        </div>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    flat: { type: Boolean, default: false },
    type: { type: Boolean, default: false },
    label: { type: String, require: true },
    errorMessages: { type: Array, require: true },

    outlined: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    counter: { type: Boolean, default: false },
    filled: { type: Boolean, default: false },
    showKey: { type: String },
    rounded: { type: Boolean, default: false },
  },
  data() {
    return {
      model: this.value,
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) this.model = newVal;
    },
    model(newVal, oldVal) {
      if (newVal !== oldVal) this.$emit("input", newVal);
    },
  },
  computed: {
    hideDetails() {
      if (this.errorMessages && this.errorMessages.length) {
        return false;
      }
      return true;
    },
  },
  methods: {
    handleKey() {
      this.$emit(this.showKey);
    },
  },
};
</script>

<style scoped>
.ps-text-field ::v-deep .v-input__append-inner {
  transform: translateY(5px);
}
</style>
